 <template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div class="vx-row mb-6">
      <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/3 xl:w-2/3 mb-base">-->
      <div class="vx-col w-full mb-base">
        <vx-card title>
          <div v-if="order" class="mt-5">
            <div class="vx-row mb-6">
              <div class="vx-col">
                <p>Código Pedido:</p>
              </div>
              <div class="vx-col">
                <vs-chip color="success">{{ order.idEquipmentOrder }}</vs-chip>
              </div>
              <div class="vx-col">
                <p>Cliente</p>
              </div>
              <div class="vx-col">
                <vs-chip color="success">{{ order.corporateName }}</vs-chip>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col">
                <p>Etapa</p>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col">
                <vs-radio
                  color="#1E90FF"
                  v-model="newStage"
                  vs-value="Conferência"
                  >Conferência</vs-radio
                >
              </div>
              <div class="vx-col">
                <vs-radio
                  color="success"
                  v-model="newStage"
                  vs-value="Faturamento"
                  >Faturamento</vs-radio
                >
              </div>
              <div class="vx-col">
                <vs-radio
                  color="warning"
                  v-model="newStage"
                  vs-value="Instalado"
                  >Instalado</vs-radio
                >
              </div>
              <div class="vx-col">
                <vs-radio
                  color="primary"
                  v-model="newStage"
                  vs-value="Concluído"
                  >Concluído</vs-radio
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col">
                <vs-list>
                  <vs-list-header
                    title="Histórico"
                    color="danger"
                  ></vs-list-header>
                  <div v-for="(item, index) of stages" :key="index">
                    <vs-list-item
                      icon-pack="feather"
                      icon="icon-check"
                      title="Data"
                      :subtitle="item.date"
                    ></vs-list-item>
                    <vs-list-item :title="item.userName" :subtitle="item.note">
                      <template slot="avatar">
                        <vs-avatar :src="item.photo" />
                      </template>
                    </vs-list-item>
                  </div>
                </vs-list>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  name="newNote"
                  label-placeholder="Observação"
                  v-model="newNote"
                />
              </div>
            </div>
            <vs-button
              class="mr-6"
              icon-pack="feather"
              icon="icon-save"
              @click="submitData()"
              >Salvar</vs-button
            >
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <!--  <div class="vx-col w-full w-1/2 mt-5">
              <h6 class="mb-2">Nome Arquivo</h6>
              <vs-input
                name="recipient1"
                v-model="fileName"
                class="w-full"
                v-validate="'required'"
              />
              <br />
              <span class="text-danger">{{ errors.first("fileName") }}</span>
            </div>-->
          </div>
          <div class="vx-row">
            <div class="vx-col mt-5">
              <input
                single
                type="file"
                class="hidden"
                ref="attachmentInput"
                @change="attachFile()"
                accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                application/vnd.openxmlformats-officedocument.wordprocessingml.documen"
                name="file"
              />
              <!--    accept="application/pdf, image/*, vnd.openxmlformats-officedocument.spreadsheetml.sheet "-->
              <vs-button
                color="primary"
                @click="$refs.attachmentInput.click()"
                icon-pack="feather"
                icon="icon-upload"
              >
                Selecione os arquivos
              </vs-button>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-full mt-5">
              <vs-list :key="indextr" v-for="(item, indextr) in items">
                <vs-list-item
                  :title="item.name"
                  :subtitle="item.type"
                ></vs-list-item>
              </vs-list>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-full mt-5" v-if="showSaveButton">
              <vs-button
                class="float-right"
                color="success"
                @click="submitAttachment"
                >Salvar</vs-button
              >
              <vs-button class="float-left" color="warning" @click="clean"
                >Limpar</vs-button
              >
            </div>
          </div>
          <div class="vx-row">
            <br />
          </div>
          <div class="vx-col w-full mb-base">
            <div class="vx-row">
              <vue-good-table
                ref="my-table"
                selectionInfoClass="mytable"
                style="width: 100%"
                styleClass="vgt-table condensed"
                :search-options="{
                  enabled: true,
                  trigger: '',
                  placeholder: 'Procurar',
                  skipDiacritics: true,
                }"
                :pagination-options="paginationOptions"
                :columns="columns"
                :rows="attachments"
                @on-row-click="onRowClick"
              >
                <div slot="emptystate" class="text-center">
                  Nenhum resultado encontrado
                </div>
                <template slot="table-row" slot-scope="attachment">
                  <span
                    class="font-medium"
                    v-if="attachment.column.field == 'name'"
                  >
                    <vs-chip color="success">{{ attachment.row.name }}</vs-chip>
                  </span>
                  <span
                    class="font-medium"
                    v-if="attachment.column.field == 'createByUsername'"
                  >
                    {{ attachment.row.createByUsername }}
                  </span>

                  <span
                    class="font-medium"
                    v-if="attachment.column.field == 'createAt'"
                  >
                    {{ attachment.row.createAt }}
                  </span>
                  <span v-if="attachment.column.field === 'attachmentId'">
                    <div align="center">
                      <vs-dropdown vs-custom-content vs-trigger-click>
                        <a
                          class="flex items-center"
                          style="font-weight: 500; font-size: 1rem"
                          href="#"
                        >
                          Mais <i class="material-icons"> expand_more </i>
                        </a>
                        <vs-dropdown-menu class="w-48">
                          <vs-dropdown-item
                            @click="
                              download(
                                attachment.row.attachmentId,
                                attachment.row.fullPath,
                                attachment.row.name
                              )
                            "
                            ><font-awesome-icon
                              :icon="['far', 'file-pdf']"
                              class="w-4"
                            />
                            Download
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template> 
<script>
import axios from "axios";
import { Validator } from "vee-validate";
import { baseApiUrl } from "@/global";
import { momentJS } from "@/helpers";
import router from "@/router";
import { fileTools } from "@/helpers";
import { VueGoodTable } from "vue-good-table";

const dict = {
  custom: {},
};

Validator.localize("en", dict);
export default {
  components: { VueGoodTable },
  data() {
    return {
      attachments: [],
      order: null,
      newStage: null,
      stages: [],
      newNote: null,
      currentAttachment: {},
      showSaveButton: false,
      fileTools: null,
      fileName: null,
      items: [],
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
      itemsPerPage: 100,
      isMounted: false,
    };
  },
  methods: {
    async attachFile() {
      this.showSaveButton = true;
      for (const element of this.$refs.attachmentInput.files) {
        let base64 = await this.fileTools.toBase64(element);
        let fileName = element.name;
        let type = element.type;
        let item = {
          name: fileName.toUpperCase(),
          file: base64,
          type: type,
        };
        this.items.push(item);
      }
    },
    async clean() {
      this.items = [];
      this.showSaveButton = false;
    },
    async download(attachmentId, fullPath, nameFile) {
      this.$vs.loading();
      try {
        let attachment = {
          attachmentId: attachmentId,
          fullPath: fullPath,
        };
        const response = await axios.post(
          `${baseApiUrl}/equipmentOrder/downloadAttachment`,
          attachment
        );
        if (response.data && response.data.base64) {
          const base64Data = response.data.base64;
          const contentType = response.data.type;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: contentType });

          // Criar um link de download
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `${nameFile}`; // Usa o nome original para salvar
          link.setAttribute("download", fileName);
          // Clicar no link programaticamente
          link.style.display = "none"; // Garante que o link não seja visível na página
          document.body.appendChild(link);
          link.click();

          // Remover o link do DOM
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async submitData() {
      try {
        if (!this.newNote) {
          this.newNote = "Nenhuma Observação";
        }

        let data = {
          order: {
            stage: this.newStage,
            idEquipmentOrder: this.order.idEquipmentOrder,
          },
          stage: {
            note: `${this.newStage} - ${this.newNote}`,
            date: momentJS().getDateTime(),
            fk_idEquipmentOrder: this.order.idEquipmentOrder,
            fk_idUser: this.$store.state.user.idUser,
            fk_idCustomer: this.order.idCustomer,
          },
        };
        this.$vs.loading();
        const response = await axios.post(
          `${baseApiUrl}/equipmentOrder/editStage`,
          data
        );
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
      this.$router.push(`/equipamentos`).catch((err) => {});
    },
    async submitAttachment() {
      const haveErrors = !(await this.$validator.validateAll());
      if (haveErrors) return;
      let data = {
        createAt: momentJS().getDateTime(),
        createBy: this.$store.state.user.idUser,
        fk_idEquipmentOrder: this.$route.params.idEquipmentOrder,
        items: this.items,
      };
      try {
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/equipmentOrder/newAttachment`, data);
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router
          .push(`/etapa-equipamentos/${this.$route.params.idEquipmentOrder}`)
          .catch(() => {});
        await this.loadAttachments();
        this.clean();
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
        this.items = [];
      }
    },
    async loadAttachments() {
      try {
        this.$vs.loading();
        const response = await axios.get(
          `${baseApiUrl}/equipmentOrder/getAttachmentById/${this.$route.params.idEquipmentOrder}`
        );
        this.attachments = response.data;
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    onRowClick(params) {
      // Somente para ter a mão do mouse clique
    },
    mountTable() {
      this.columns = [
        {
          label: "Nome do Arquivo ",
          field: "name",
          tdClass: "align-middle",
        },
        {
          label: "Criado por",
          field: "createByUsername",
          tdClass: "align-middle",
        },
        {
          label: "Data criação",
          field: "createAt",
          tdClass: "align-middle",
          dateInputFormat: "dd/MM/yyyy",
          dateOutputFormat: "dd/MM/yyyy",
        },
        {
          label: "Ação",
          field: "attachmentId",
          tdClass: "align-middle",
        },
      ];
    },
  },
  async created() {
    //O correto seria a etapa ID e nao ID idEquipmentOrder
    console.log(this.$route.params.idEquipmentOrder);
    await this.loadAttachments();
    this.fileTools = fileTools();
    try {
      this.$vs.loading();
      const response = await axios.get(
        `${baseApiUrl}/equipmentOrder/getStageEquipmentOrderById/${this.$route.params.idEquipmentOrder}`
      );
      //Format Date Moment
      response.data.stages.forEach((item) => {
        item.date = momentJS().formatDateTimeForPTBR(item.date);
      });
      this.order = response.data.order;
      this.newStage = response.data.order.stage;
      this.stages = response.data.stages;
      this.$vs.loading.close();
    } catch (error) {
      console.log(error);

      this.$vs.notify({
        title: "Erro",
        text: "Não foi possivel carregar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });
      if (error.response.status == "400") {
        router.push("/equipamentos").catch(() => {});
      }
    } finally {
      this.$vs.loading.close();
    }
    this.mountTable();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script> 
